const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.pairfon.com";

export default API_BASE_URL;
